var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorBenefits2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89.721,
    height: 86.819,
    viewBox: "0 0 89.721 86.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25634",
    "data-name": "Rectangle 25634",
    width: 89.721,
    height: 86.819,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88051",
    "data-name": "Group 88051",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88050",
    "data-name": "Group 88050",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308542",
    "data-name": "Path 308542",
    d: "M67.075,33.672c0-12.138-10.418-21.978-22.216-21.978s-22.215,9.84-22.215,21.978A22.111,22.111,0,0,0,30.807,50.31a11.464,11.464,0,0,1,4.047,8.752V70.977H54.865V59.062a11.463,11.463,0,0,1,4.046-8.751,22.113,22.113,0,0,0,8.164-16.639",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308543",
    "data-name": "Path 308543",
    d: "M38.684,58.1a11.461,11.461,0,0,0-4.047-8.751,22.115,22.115,0,0,1-8.163-16.639A22.321,22.321,0,0,1,41.59,11.947C31.2,13.556,22.644,22.67,22.644,33.672A22.111,22.111,0,0,0,30.807,50.31a11.464,11.464,0,0,1,4.047,8.752V70.977H54.865v-.958H38.684Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308544",
    "data-name": "Path 308544",
    d: "M44.859,11.694a21.433,21.433,0,0,0-2.141.108,1.867,1.867,0,0,0-1.689,1.852v.012a1.858,1.858,0,0,0,1.858,1.858h1.972A18.512,18.512,0,0,1,63.244,33.672v1.972a1.859,1.859,0,0,0,3.707.208,19.175,19.175,0,0,0,.124-2.18C67.075,21.534,56.657,11.694,44.859,11.694Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308545",
    "data-name": "Path 308545",
    d: "M55.811,53.585a1.245,1.245,0,1,1-1.245,1.245,1.244,1.244,0,0,1,1.245-1.245",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4998",
    "data-name": "Ellipse 4998",
    cx: 11.21,
    cy: 11.154,
    rx: 11.21,
    ry: 11.154,
    transform: "translate(33.649 22.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308546",
    "data-name": "Path 308546",
    d: "M54.268,66.72H35.451a3.066,3.066,0,0,0,0,6.133H54.268a3.066,3.066,0,1,0,0-6.133",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308547",
    "data-name": "Path 308547",
    d: "M36.215,69.787a3.066,3.066,0,0,1,3.066-3.067H35.45a3.067,3.067,0,0,0,0,6.134h3.831a3.066,3.066,0,0,1-3.066-3.067",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308548",
    "data-name": "Path 308548",
    d: "M44.86,10.736c-12.561,0-23.173,10.5-23.173,22.935a22.987,22.987,0,0,0,8.5,17.37,10.484,10.484,0,0,1,3.707,8.02v.88a4.019,4.019,0,0,0-1.044,6.778,4.021,4.021,0,0,0,2.6,7.091h1.375a8.2,8.2,0,0,0,16.067,0h1.375a4.021,4.021,0,0,0,2.6-7.091,4.021,4.021,0,0,0-2.6-7.091H49.647V45.284a12.167,12.167,0,1,0-9.576,0V59.628H35.812v-.567a12.4,12.4,0,0,0-4.385-9.482A21.077,21.077,0,0,1,23.6,33.671c0-11.394,9.735-21.02,21.258-21.02s21.258,9.626,21.258,21.02a21.078,21.078,0,0,1-7.826,15.908.958.958,0,0,0,1.238,1.462,22.985,22.985,0,0,0,8.5-17.37C68.033,21.239,57.421,10.736,44.86,10.736Zm-.575-1.161a.958.958,0,0,1-.958-.957V.957a.958.958,0,0,1,1.916,0V8.618a.958.958,0,0,1-.958.957M33.591,11.931a.957.957,0,0,1-.884-.591L31.242,7.8a.957.957,0,0,1,1.769-.733l1.466,3.539a.962.962,0,0,1-.886,1.324m-14.873,15.5a.967.967,0,0,1-.366-.073l-3.539-1.466a.958.958,0,0,1,.733-1.77l3.539,1.466a.963.963,0,0,1-.367,1.843m-3.1,22.939a.959.959,0,0,1-.367-1.842l3.539-1.466a.957.957,0,0,1,.733,1.769l-3.539,1.466A.948.948,0,0,1,15.62,50.366Zm58.918-1.061a.941.941,0,0,1-.365-.074l-3.54-1.465A.958.958,0,0,1,71.367,46l3.539,1.466A.963.963,0,0,1,74.538,49.305Zm-3.976-22.94a.963.963,0,0,1-.368-1.843l3.538-1.465a.957.957,0,1,1,.733,1.769l-3.538,1.466a.959.959,0,0,1-.365.073m-15.5-14.873a.963.963,0,0,1-.883-1.325l1.465-3.538a.958.958,0,0,1,1.77.732L55.95,10.9A.958.958,0,0,1,55.064,11.492ZM24.614,18.2a.954.954,0,0,1-.677-.28L18.52,12.5a.958.958,0,0,1,1.355-1.354l5.416,5.417a.963.963,0,0,1-.677,1.634M16.8,38.207H9.142a.958.958,0,0,1,0-1.915H16.8a.958.958,0,0,1,0,1.915m63.773-1.149h-7.66a.957.957,0,1,1,0-1.915h7.66a.957.957,0,1,1,0,1.915M64.292,17.387a.964.964,0,0,1-.676-1.635l5.416-5.417a.958.958,0,0,1,1.354,1.355l-5.417,5.416a.953.953,0,0,1-.677.281m-25.353,17.9a.958.958,0,0,1,1.274-1.432l2.926,2.6,6.311-6.6a.957.957,0,1,1,1.384,1.323l-6.947,7.271a.96.96,0,0,1-1.33.054Zm8.794,10.632v13.71H41.986V45.919a12.173,12.173,0,0,0,5.747,0m6.535,21.758a2.109,2.109,0,0,1,0,4.218H35.451a2.109,2.109,0,1,1,0-4.218Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308549",
    "data-name": "Path 308549",
    d: "M81.259,64.63a1.156,1.156,0,0,1,.22-.668,3.447,3.447,0,1,0-5.733-.148,1.251,1.251,0,0,1-.945,1.945H68.563V71.85a1.251,1.251,0,0,0,1.945.946,3.447,3.447,0,1,1-.141,5.738,1.134,1.134,0,0,0-1.8.9v6.424h20.2v-20.1H82.388A1.128,1.128,0,0,1,81.259,64.63Z",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25632",
    "data-name": "Rectangle 25632",
    width: 3.83,
    height: 20.103,
    transform: "translate(84.931 65.759)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308550",
    "data-name": "Path 308550",
    d: "M68.563,65.759V71.85a1.251,1.251,0,0,0,1.945.946,3.422,3.422,0,0,1,1.5-.513V65.759Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308551",
    "data-name": "Path 308551",
    d: "M8.459,64.63a1.156,1.156,0,0,0-.22-.668,3.447,3.447,0,1,1,5.733-.148,1.251,1.251,0,0,0,.945,1.945h6.238V71.85a1.251,1.251,0,0,1-1.945.946,3.447,3.447,0,1,0,.141,5.738,1.134,1.134,0,0,1,1.8.9v6.424H.957v-20.1H7.33A1.128,1.128,0,0,0,8.459,64.63Z",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25633",
    "data-name": "Rectangle 25633",
    width: 3.83,
    height: 20.103,
    transform: "translate(0.958 65.759)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308552",
    "data-name": "Path 308552",
    d: "M21.156,65.759V71.85a1.251,1.251,0,0,1-1.945.946,3.422,3.422,0,0,0-1.5-.513V65.759Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308553",
    "data-name": "Path 308553",
    d: "M21.156,86.819H.957A.958.958,0,0,1,0,85.862v-20.1A.958.958,0,0,1,.957,64.8H7.33a.171.171,0,0,0,.127-.286,4.405,4.405,0,1,1,7.324-.189c-.087.112-.055.493.136.475h6.238a.958.958,0,0,1,.958.958v6.082A2.219,2.219,0,0,1,18.7,73.605a2.461,2.461,0,0,0-1.636-.364,2.49,2.49,0,0,0,.314,4.96,2.458,2.458,0,0,0,1.41-.441,2.105,2.105,0,0,1,3.327,1.69v6.411A.958.958,0,0,1,21.156,86.819ZM1.915,84.9H20.2V79.438a.175.175,0,0,0-.3-.121,4.368,4.368,0,0,1-2.525.8,4.405,4.405,0,0,1-.548-8.776,4.366,4.366,0,0,1,2.894.647c.112.087.493.054.475-.137V66.717H14.926A2.22,2.22,0,0,1,13.163,63.3a2.473,2.473,0,0,0,.383-1.321,2.49,2.49,0,0,0-4.967-.248,2.458,2.458,0,0,0,.443,1.678A2.1,2.1,0,0,1,7.33,66.717H1.915Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308554",
    "data-name": "Path 308554",
    d: "M67.608,85.862V79.451a2.105,2.105,0,0,1,3.327-1.69,2.464,2.464,0,0,0,1.41.44,2.49,2.49,0,0,0,.314-4.96,2.467,2.467,0,0,0-1.636.364,2.219,2.219,0,0,1-3.415-1.763V65.76a.958.958,0,0,1,.958-.958H74.8c.191.018.223-.363.136-.476a4.382,4.382,0,0,1-.68-2.346,4.4,4.4,0,1,1,8,2.535.172.172,0,0,0,.127.287h6.373a.958.958,0,0,1,.957.958v20.1a.958.958,0,0,1-.957.958h-20.2A.958.958,0,0,1,67.608,85.862Zm20.2-19.145H82.391A2.1,2.1,0,0,1,80.7,63.41a2.462,2.462,0,0,0,.443-1.678,2.49,2.49,0,0,0-4.967.248,2.473,2.473,0,0,0,.383,1.321,2.219,2.219,0,0,1-1.763,3.416H69.523V71.85c-.018.192.364.224.475.137a4.366,4.366,0,0,1,2.894-.647,4.405,4.405,0,0,1-.547,8.776,4.369,4.369,0,0,1-2.526-.8.175.175,0,0,0-.3.121V84.9H87.806Z",
    fill: "#515255"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorBenefits2);
export default __webpack_public_path__ + "static/media/Mentor_Benefits_2.9cea005e7d86f87647052e6ad0187604.svg";
export { ForwardRef as ReactComponent };